import { useEffect } from 'react';

import { getDwellTimeTracker } from '@confluence/dwell';

import { useAnalytics } from '../AnalyticsProvider.tsx';

// A safer version of import { useDwellTime } from "@confluence/dwell";
// Doesn't fire events until searchSessionId is available, which isn't the first time the hook is fired
// See QS-3696
export const useSessionSafeDwellTime = (): void => {
	const { searchSessionId, fireAnalytics } = useAnalytics();

	useEffect(() => {
		if (searchSessionId) {
			const eventData = buildEventData(searchSessionId);
			void getDwellTimeTracker().then((tracker) => {
				void tracker.startAny(eventData, (callbackData) => {
					// When leaving the page and using browser-back to reenter, we get a second invalid finalDwellEvent
					// It is unclear how this is happening, and the pattern here already matches recommended implementation in import { useDwellTime } from "@confluence/dwell"
					// We can safely ignore this event
					const { dwellTime, finalDwellEvent } = callbackData.attributes;
					if (finalDwellEvent && !dwellTime) {
						return;
					}

					fireAnalytics({
						type: 'sendTrackEvent',
						action: 'dwelled',
						actionSubject: callbackData.actionSubject,
						additionalAttributes: callbackData.attributes,
					});
				});
			});
		}
		return () => {
			void getDwellTimeTracker().then((tracker) => {
				tracker.stop();
			});
		};
	}, [searchSessionId, fireAnalytics]);
};

const buildEventData = (searchSessionId) => ({
	source: 'advancedSearchScreen',
	actionSubject: 'searchPage',
	attributes: {
		searchSessionId,
		isFullPageSearch: false,
	},
});
